import { render, staticRenderFns } from "./tiscFile.vue?vue&type=template&id=537dc444&scoped=true&"
import script from "./tiscFile.vue?vue&type=script&lang=js&"
export * from "./tiscFile.vue?vue&type=script&lang=js&"
import style0 from "./tiscFile.vue?vue&type=style&index=0&id=537dc444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537dc444",
  null
  
)

export default component.exports